import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/ui/organisms/PageHeader';
import Eyebrow from '@/ui/atoms/Eyebrow';
import Button from '@/ui/atoms/Button';

// /how-it-works — long-form brand education.
// Mount: top-nav (when signed in) + Onboarding step-0 footer + site Footer.
// ADDENDUM correction 9.
export default function HowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { i18n: 'howItWorks.step1', tone: 'azure' as const },
    { i18n: 'howItWorks.step2', tone: 'gold' as const },
    { i18n: 'howItWorks.step3', tone: 'jade' as const },
    { i18n: 'howItWorks.step4', tone: 'vermilion' as const },
  ];
  return (
    <div className="max-w-3xl mx-auto px-8 py-16" data-testid="how-it-works-root">
      <PageHeader
        eyebrow={t('nav.howItWorks')}
        title={t('howItWorks.title')}
        sub={t('howItWorks.sub')}
      />
      <ol className="space-y-8">
        {steps.map((s, idx) => (
          <li
            key={s.i18n}
            className="px-6 py-5 border border-hairline rounded-md bg-paper"
            data-testid={`how-step-${idx + 1}`}
          >
            <div className="flex items-baseline gap-3 mb-2">
              <Eyebrow tone={s.tone}>STEP {idx + 1}</Eyebrow>
              <h2 className="font-serif text-xl font-medium">
                {t(`${s.i18n}Title`)}
              </h2>
            </div>
            <p className="text-ink-2 leading-relaxed">{t(`${s.i18n}Body`)}</p>
          </li>
        ))}
      </ol>
      <div className="mt-10">
        <Link to="/dashboard">
          <Button variant="secondary">{t('howItWorks.back')}</Button>
        </Link>
      </div>
    </div>
  );
}
